import { createAuthClient } from '@storebrand-digital/auth';
var options = {
    config: {
        realm: window.env.KEYCLOAK_REALM,
        clientId: window.env.KEYCLOAK_CLIENT,
        url: window.env.KEYCLOAK_URL,
    },
    init: {
        scopes: [window.env.KEYCLOAK_SCOPES],
    },
    login: {
        scope: window.env.KEYCLOAK_SCOPES,
        allowedACR: [
            'https://id.storebrand.no/authn/al4',
            'https://id.storebrand.no/authn/al3',
        ],
    },
};
var auth = createAuthClient(options);
export default auth;
